import { styled, TextField } from '@mui/material'

export const STextField = styled(TextField)(({ theme }) => ({
  '& .MuiInput-root .MuiInput-input': { padding: '8px 4px 0 0' },
  '& input::placeholder': {
    opacity: 0.6,
    color: theme.palette.common.black,
  },
}))
